import { render } from "./chart.vue?vue&type=template&id=586dda1a&ts=true"
import script from "./chart.vue?vue&type=script&lang=ts&config=true"
export * from "./chart.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__